import React from "react";
import styled from "@emotion/styled";
import mediaqueries from "@styles/media";

import FooterLinksSection from "@components/Navigation/Navigation.Footer.Links.List";

const Links: React.FC<{}> = () => {
  const baseUrl = 'https://get-base.com';
  const trackLinksSectionData = [
    { text: 'Sleep', href: `${baseUrl}/area/sleep`},
    { text: 'Diet', href: `${baseUrl}/area/diet`},
    { text: 'Energy', href: `${baseUrl}/area/energy`},
    { text: 'Stress', href: `${baseUrl}/area/stress`},
    { text: 'SexDrive', href: `${baseUrl}/area/sex-drive`},
    { text: 'Shop all', href: `${baseUrl}/products`},
    { text: 'Quiz', href: `${baseUrl}/quiz`},
  ];
  const baseLinksSectionData = [
    { text: 'Our Company', href: `${baseUrl}/about`},
    { text: 'Science/Why Blood', href: `${baseUrl}/science`}
  ];
  const helpLinksSectionData = [
    { text: 'Contact', href: `mailto:info@get-base.com`},
    { text: 'Terms', href: `${baseUrl}/terms`},
    { text: 'Privacy Policy', href: `${baseUrl}/privacy-policy`},
  ];
  const baseLinksSectionMobileData = [
    { text: 'Our Company', href: `${baseUrl}/about`},
    { text: 'Science/Why Blood', href: `${baseUrl}/science`},
    ...helpLinksSectionData
  ];
  return (
    <>
      <FooterLinksContainer>
        <FooterLinksSection title="Tracks" linksData={trackLinksSectionData} />
        <FooterLinksContainerDesktop>
          <FooterLinksSection title="Base" linksData={baseLinksSectionData} />
          <FooterLinksSection title="Help" linksData={helpLinksSectionData} />
        </FooterLinksContainerDesktop>
        <FooterLinksContainerMobile>
          <FooterLinksSection title="Base" linksData={baseLinksSectionMobileData} />
        </FooterLinksContainerMobile>
      </FooterLinksContainer>
    </>
  );
};

const FooterLinksContainer = styled.div`
  display: flex;
  
  ${mediaqueries.tablet`
    padding-left: 16px;
  `}
`;

const FooterLinksContainerDesktop = styled.div`
  display: flex;
  
  ${mediaqueries.tablet`
    display: none;
  `}
`;

const FooterLinksContainerMobile = styled.div`
  display: none;
  
  ${mediaqueries.tablet`
    display: flex;
  `}
`;

export default Links;
